/* Order forms: Deutsch. Gleiche Struktur wie order-forms-en.js.
   Anrede mit "du". Die Auswahlmöglichkeiten werden in `options` über ihren englischen Wert übersetzt:
   dieser Wert wird an Notion gesendet. Formular EU: Titel und Button nach der Widerrufsfunktion
   ("Vertrag widerrufen" / "Widerruf bestätigen"). */
window.OrderFormsI18n = window.OrderFormsI18n || {};
window.OrderFormsI18n.de = {
  ui: {
    next: 'Weiter',
    back: 'Zurück',
    submit: 'Absenden',
    sending: 'Wird gesendet…',
    required: 'Bitte fülle dieses Feld aus.',
    email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    files_choose: 'Klicke, um eine Datei auszuwählen, oder ziehe sie hierher',
    files_hint: 'Bis zu 10 Bilder, je max. 5 MB',
    too_many: 'Du kannst hier bis zu 10 Dateien hinzufügen.',
    too_big: 'Jede Datei darf höchstens 5 MB groß sein.',
    file_type: 'Bitte lade ein Bild oder ein PDF hoch.',
    remove: 'Entfernen',
    error: 'Etwas ist schiefgelaufen und deine Anfrage wurde nicht gesendet. Bitte versuche es gleich noch einmal.'
  },
  resolution: {
    title: 'Hilfe zu deiner Bestellung',
    fields: {
      help_with: 'Wobei können wir dir helfen?',
      order_number: 'Bestellnummer',
      email: 'E-Mail-Adresse, mit der du bestellt hast',
      full_name: 'Vollständiger Name auf der Bestellung',
      postcode: 'Postleitzahl der Lieferadresse',
      card_last4: 'Die letzten 4 Ziffern der verwendeten Karte',
      issue_type: 'Was ist das Problem mit deiner Bestellung?',
      tracking_status: 'Was zeigt die Sendungsverfolgung gerade an?',
      checked_places: 'Bevor du weitermachst, bestätige bitte, dass du an jedem dieser Orte nachgesehen hast',
      delivery_address: 'Vollständige Lieferadresse, genau so, wie du sie eingegeben hast',
      damage_photos: 'Fotos vom Schaden',
      packaging_photo: 'Foto der äußeren Verpackung, auf dem das Versandetikett zu sehen ist',
      item_usable: 'Ist der Artikel noch nutzbar?',
      damage_description: 'Beschreibe den Schaden in deinen eigenen Worten',
      item_received_photo: 'Foto des erhaltenen Artikels',
      shipping_label_photo: 'Foto des Versandetiketts',
      wrong_what: 'Was stimmt nicht?',
      order_vs_received: 'Was hast du bestellt und was hast du erhalten?',
      date_received: 'Datum, an dem du den Artikel erhalten hast',
      item_condition: 'Wurde der Artikel geöffnet oder benutzt?',
      return_reason: 'Warum möchtest du ihn zurückgeben?',
      return_photo: 'Foto des Artikels in seinem aktuellen Zustand',
      exchange_reason: 'Warum möchtest du ihn umtauschen?',
      exchange_details: 'Welchen Artikel möchtest du umtauschen und was möchtest du stattdessen? Gib Größe, Farbe oder den Produktnamen an.',
      exchange_date_received: 'Datum, an dem du den Artikel erhalten hast',
      exchange_condition: 'Wurde der Artikel geöffnet oder benutzt?',
      exchange_photo: 'Foto des Artikels in seinem aktuellen Zustand (wenn er defekt ist, zeig bitte den Defekt)',
      exchange_packaging_photo: 'Foto der Originalverpackung',
      exchange_confirmations: 'Bitte bestätige vor dem Absenden',
      charge_date: 'Datum der Abbuchung',
      charge_amount: 'Betrag und Währung der Abbuchung',
      statement_descriptor: 'Wie genau erscheint die Abbuchung auf deinem Kontoauszug?',
      household_use: 'Könnte eine andere Person in deinem Haushalt diese Karte benutzt haben?',
      statement_screenshot: 'Screenshot der Abbuchung auf deinem Kontoauszug',
      requested_resolution: 'Wie sollen wir das Problem für dich lösen?',
      bank_contacted: 'Hast du wegen dieser Abbuchung schon deine Bank oder deinen Kartenaussteller kontaktiert?',
      confirmations: 'Bitte bestätige vor dem Absenden'
    },
    placeholders: {
      exchange_details: 'Beispiel: Ich habe [Produktname] in [Größe, Farbe oder Modell] erhalten und möchte ihn gegen [Produktname] in [Größe, Farbe oder Modell] umtauschen.'
    },
    options: {
      'I want to exchange a product': 'Ich möchte einen Artikel umtauschen',
      'Where is my order?': 'Wo ist meine Bestellung?',
      'I want to cancel an order I just placed': 'Ich möchte eine gerade aufgegebene Bestellung stornieren',
      "There's a problem with the order I received": 'Es gibt ein Problem mit meiner erhaltenen Bestellung',
      'I want to return something': 'Ich möchte etwas zurückgeben',
      "I don't recognise a charge from this store": 'Ich erkenne eine Abbuchung dieses Shops nicht',
      'My order never arrived': 'Meine Bestellung ist nie angekommen',
      'It arrived damaged or faulty': 'Sie ist beschädigt oder defekt angekommen',
      'I received the wrong item': 'Ich habe den falschen Artikel erhalten',
      'I changed my mind and want to return it': 'Ich habe es mir anders überlegt und möchte sie zurückgeben',
      "I don't recognise this charge": 'Ich erkenne diese Abbuchung nicht',
      "I want to cancel an order that hasn't shipped yet": 'Ich möchte eine Bestellung stornieren, die noch nicht versendet wurde',
      'No updates for more than 7 days': 'Seit mehr als 7 Tagen keine Aktualisierung',
      "Marked as delivered - but I didn't receive it": 'Als zugestellt markiert, aber ich habe sie nicht erhalten',
      'Returned to sender': 'An den Absender zurückgeschickt',
      "I can't find my tracking number": 'Ich finde meine Sendungsnummer nicht',
      'The mailbox and around the entrance': 'Im Briefkasten und rund um den Eingang',
      'With neighbours or building reception': 'Bei den Nachbarn oder am Empfang des Gebäudes',
      'With your local post office or depot': 'Bei deiner Postfiliale oder deinem Paketshop',
      'Whether someone else at the address received it': 'Ob eine andere Person an der Adresse sie angenommen hat',
      'Yes - partially usable': 'Ja, teilweise',
      'No - completely unusable': 'Nein, er ist komplett unbrauchbar',
      'Wrong size': 'Falsche Größe',
      'Wrong colour': 'Falsche Farbe',
      'Completely different product': 'Ein ganz anderes Produkt',
      'Items missing from my order': 'In meiner Bestellung fehlen Artikel',
      'Unopened - still in original packaging': 'Ungeöffnet, noch in der Originalverpackung',
      'Opened but unused': 'Geöffnet, aber nicht benutzt',
      'Used': 'Benutzt',
      "Doesn't fit": 'Passt nicht',
      'Not what I expected': 'Nicht das, was ich erwartet habe',
      'Arrived later than I needed': 'Kam zu spät an',
      'No longer needed': 'Brauche ich nicht mehr',
      'Found it cheaper elsewhere': 'Woanders günstiger gefunden',
      'The item is defective': 'Der Artikel ist defekt',
      'I need a different size': 'Ich brauche eine andere Größe',
      "I'd like a different colour": 'Ich möchte eine andere Farbe',
      "I'd like a different model": 'Ich möchte ein anderes Modell',
      "I'd like a different product": 'Ich möchte ein anderes Produkt',
      'I confirm the information above is accurate.': 'Ich bestätige, dass die obigen Angaben korrekt sind.',
      "I have read and accept the store's Refund Policy.": 'Ich habe die Rückerstattungsrichtlinie des Shops gelesen und akzeptiere sie.',
      'I confirm the information above is accurate and that I am the cardholder or an authorised user of the payment method used for this order.': 'Ich bestätige, dass die obigen Angaben korrekt sind und dass ich Inhaber:in oder berechtigte Nutzer:in des für diese Bestellung verwendeten Zahlungsmittels bin.',
      'If this issue is resolved to my satisfaction, I agree to inform my bank to withdraw any dispute I may have filed regarding this charge.': 'Wenn das Problem zu meiner Zufriedenheit gelöst wird, verpflichte ich mich, meine Bank zu bitten, eine eventuell eingereichte Reklamation zu dieser Abbuchung zurückzuziehen.',
      'Yes': 'Ja',
      'No': 'Nein',
      'Not sure': 'Ich bin mir nicht sicher',
      'Send me a replacement - free of charge': 'Ersatzlieferung, kostenlos',
      'Store credit worth 120% of my order': 'Ein Guthaben über 120 % meines Bestellwerts',
      'Partial refund - and I keep the item': 'Teilerstattung, und ich behalte den Artikel',
      'Full refund': 'Vollständige Erstattung'
    },
    contact: 'Möchtest du {store} direkt erreichen? Schreib an {email} und gib deine Bestellnummer an.',
    thanks: [
      'Danke. Wir haben deine Angaben erhalten.',
      'Unser Team prüft deine Anfrage und antwortet dir innerhalb von 24 Stunden per E-Mail.',
      'Wenn du unsere Antwort nicht findest, schau bitte auch in deinem Spam-Ordner nach. Wenn du auf diese E-Mail antwortest, erreichst du am schnellsten die Person, die sich um deine Anfrage kümmert.'
    ]
  },
  eu: {
    title: 'Vertrag widerrufen',
    submit: 'Widerruf bestätigen',
    fields: {
      full_name: 'Vollständiger Name',
      email: 'E-Mail-Adresse, mit der du bestellt hast',
      order_number: 'Bestellnummer',
      purchase_date: 'Bestelldatum',
      received_date: 'Datum, an dem du die Bestellung erhalten hast',
      withdraw_scope: 'Was möchtest du widerrufen?',
      items: 'Wenn nur einzelne Artikel: Gib sie hier an',
      reason: 'Grund (optional)'
    },
    options: {
      withdraw_scope: { whole: 'Die gesamte Bestellung', some: 'Nur einzelne Artikel' }
    },
    thanks: [
      'Dein Widerruf ist bei uns eingegangen.',
      'Wir schicken dir eine Eingangsbestätigung per E-Mail. Deine 14 Tage und deine Erstattung zählen ab dem Moment, in dem du dieses Formular abgeschickt hast.'
    ]
  }
};
